// extracted by mini-css-extract-plugin
export var root = "_404-module--root--a64e3";
export var searchContainer = "_404-module--searchContainer--9312a";